// IMPORTANT - DO NOT SORT THESE IMPORTS, ORDER MATTERS
import "@babel/polyfill";
import Vue from "vue";
import "@/plugins/vuetify";
import "@/plugins/vue-line-clamp";
import "@/plugins/v-tooltip";
import "@/plugins/waypoint";
import router from "./router";
import { sync } from "vuex-router-sync";
import store from "@/store/index";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import App from "./App";
import {
  globalError,
  unhandledPromiseRejectionError,
  vueError
} from "@/utilities/globalErrorHandler";

sync(store, router);
Vue.config.productionTip = process.env.NODE_ENV === "production";

import "@/components/global";

Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.config.performance = process.env.NODE_ENV !== "production";

// Global error logging of vue, generic and promise errors
Vue.config.errorHandler = vueError;
window.addEventListener("error", globalError);
window.addEventListener("unhandledrejection", unhandledPromiseRejectionError);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
